import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";
export function getProductTaxes(registrationID) {
  return async (dispatch, getState) => {

    const token = getState().user.uat;

    const response = await axios.get(constants.API_URL + "/setup/taxes", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response && response.data && response.data.productTaxes) {
      const productTaxes = response.data.productTaxes;

      const taxes = productTaxes.filter(e => !e.IsDeleted);
      console.log("taxes",taxes);
      dispatch({ 
        type: actionTypes.GET_TAXES, 
         productTaxes: taxes 
      });

      return taxes;
    }
  };
}
export function saveProductTaxes(productTax, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let response;

      if (key && key.trim() !== "") {
        // UPDATE
        response = await axios.put(
          `${constants.API_URL}/catalog/taxes/${key}`,
          productTax,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // CREATE
        response = await axios.post(
          `${constants.API_URL}/catalog/taxes`,
          productTax,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        return response.data.tax.key;
      } else {
        throw new Error(response.data.message);
      }

    } catch (error) {
      console.error("Error saving tax:", error);
      throw error;
    }
  };
}

// export function saveProductTaxes(productTax, key) {
//   return (dispatch, getState) => {
//     productTax.ActionOn = firebase.firestore.FieldValue.serverTimestamp();
//     productTax.ActionBy = getState().user.user.Name;
//     productTax.ActionByUID = getState().user.user.UID;
//     productTax.ActionByEmailID = getState().user.user.EmailID;
//     if (key.trim() !== "") {
//       productTax.Action = constants.AUDIT_TRAIL_EDIT;
//       return database
//         .collection("ProductTaxes")
//         .doc(key)
//         .update({
//           ...productTax,
//         })
//         .then(() => {
//           return key;
//         })
//         .catch(function(error) {
//           console.error("Error updating product tax: ", error);
//         });
//     } else {
//       productTax.Action = constants.AUDIT_TRAIL_NEW;
//       return database
//         .collection("ProductTaxes")
//         .add({
//           ...productTax,
//         })
//         .then(function(docRef) {
//           return docRef.id;
//         })
//         .catch(function(error) {
//           console.error("Error adding product tax: ", error);
//         });
//     }
//   };
// }

export function deleteProductTax(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/taxes/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response && response.data && response.data.code === "0") {
        return true;
      } else {
        throw new Error(response.data.message || "Delete failed");
      }

    } catch (error) {
      console.error("Error deleting tax:", error);
      throw error;
    }
  };
}
